import type { MutationHookOptions } from '@apollo/client'
import {
  UpdateEmployeeRelatorioUnicoFieldDocument,
  UpdateEmployeeRelatorioUnicoFieldMutation,
  UpdateEmployeeRelatorioUnicoFieldMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Options = MutationHookOptions<
  UpdateEmployeeRelatorioUnicoFieldMutation,
  UpdateEmployeeRelatorioUnicoFieldMutationVariables
>

export const useUpdateEmployeeRelatorioUnicoField = (options?: Options) => {
  const [updateEmployeeRelatorioUnicoField, { loading }] = useMutation(
    UpdateEmployeeRelatorioUnicoFieldDocument,
    {
      ...options,
      extractorFn: (data) => data.trainingsMutations.updateTrainingsEmployeeRelatorioUnicoField,
    }
  )

  return {
    loading,
    update(variables: UpdateEmployeeRelatorioUnicoFieldMutationVariables) {
      return updateEmployeeRelatorioUnicoField({
        variables,
      })
    },
  }
}
